@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<h1 data-automation-name="registrationEditor">
  @switch(editing) {
    @case(true) {
      <span>Edit Registration {{registrationDto.registration_id}}</span>
      <p class="lead">
        Registrations may <b>not</b> be modified once they are created. Cancel the existing registration and create a new one.
      </p>
    }
    @case(false) {
      <span>Register a new Registration</span>
      <p class="lead">
        Note: After successfully creating a registration, all metadata reports associated with the specified VEN will be registered with the VTN.
        A VEN must have certs and be associated with a VTN in order to create a registration.
      </p>
    }
  }
</h1>
@if(isLoading) {
  <app-loader
    message="Loading...">
  </app-loader>
} @else {
  <form name="registrationForm" class="form-horizontal" [formGroup]="registrationForm">
    <div class="form-group">
      <label for="venId"> Ven id: </label>
      <select id="venId" class="form-control" name="ven_id" type="select" formControlName="venId" required>
        <option [ngValue]="null" disabled>Select a VEN</option>
        @for(ven of vens; track ven) {
          <option [ngValue]="ven">{{ven.id}} : {{ven.name}}</option>
        }
      </select>
      @if(registrationForm.get('venId')?.invalid && (registrationForm.get('venId')?.dirty || registrationForm.get('venId')?.touched)) {
        <div class="text-danger">
          <div *ngIf="registrationForm.get('venId')?.errors?.['required']">VEN is required.</div>
        </div>
      }
    </div>

    @if(selectedVen?.profile === '2.0a') {
      <div class="form-group">
        <label for="poll_rate">Poll rate: </label>
        <input id="poll_rate" placeholder="PT10S" class="form-control" name="poll_rate" type="text" formControlName="pollRate" required>
        @if(registrationForm.get('pollRate')?.invalid && (registrationForm.get('pollRate')?.dirty || registrationForm.get('pollRate')?.touched)) {
          <div class="text-danger">
            <div *ngIf="registrationForm.get('pollRate')?.errors?.['required']">Poll rate is required.</div>
          </div>
        }

        <label for="reply_limit">Reply limit: </label>
        <input id="reply_limit" placeholder="10" class="form-control" name="reply_limit" type="number" formControlName="replyLimit">
      </div>
    }

    @if(selectedVen?.profile === '2.0b') {
      <div class="form-group">
        <label for="reportOnly"> Report only: </label>
        <select id="reportOnly" class="form-control" name="reportOnly" type="select" formControlName="reportOnly">
          <option value="true">true</option>
          <option value="false">false</option>
        </select>
      </div>
    }

    <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="registrationForm.invalid">Save</button>
    <a class="btn" (click)="backPage('/registrations', router)">Cancel</a>
  </form>
}
